'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextBubble = require('./TextBubble');

var _TextBubble2 = _interopRequireDefault(_TextBubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.onBubbleComponentRef = function (ref) {
      return _this.tooltipBubble = ref;
    }, _this.toggleTooltip = function (ev) {
      var _ev$target$getBoundin = ev.target.getBoundingClientRect(),
          x = _ev$target$getBoundin.left,
          y = _ev$target$getBoundin.top;

      _this.tooltipBubble.setState({ show: !_this.tooltipBubble.state.show, position: { x: x, y: y } });
    }, _this.showTooltip = function (ev) {
      var _ev$target$getBoundin2 = ev.target.getBoundingClientRect(),
          x = _ev$target$getBoundin2.left,
          y = _ev$target$getBoundin2.top;

      _this.tooltipBubble.setState({ show: true, position: { x: x, y: y } });
    }, _this.hideTooltip = function (ev) {
      _this.tooltipBubble.setState({ show: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          tooltipVerticalAlignment = _props.tooltipVerticalAlignment,
          tooltipHorizontalAlignment = _props.tooltipHorizontalAlignment,
          backgroundColor = _props.backgroundColor,
          tooltipBubbleArrowClassName = _props.tooltipBubbleArrowClassName,
          tooltipBubbleContentClassName = _props.tooltipBubbleContentClassName,
          tooltipBubbleClassName = _props.tooltipBubbleClassName;

      this.tooltipContainer = document.createElement('div');
      document.body.appendChild(this.tooltipContainer);
      (0, _reactDom.render)(_react2.default.createElement(
        _TextBubble2.default,
        {
          verticalAlignment: tooltipVerticalAlignment,
          horizontalAlignment: tooltipHorizontalAlignment,
          backgroundColor: backgroundColor,
          arrowClassName: tooltipBubbleArrowClassName,
          bubbleContentClassName: tooltipBubbleContentClassName,
          className: tooltipBubbleClassName,
          componentRef: this.onBubbleComponentRef },
        this.props.children
      ), this.tooltipContainer);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.tooltipContainer.remove();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          iconContainerClassName = _props2.iconContainerClassName,
          tooltipIcon = _props2.tooltipIcon;

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'span',
          {
            className: 'luna-tooltipIcon ' + iconContainerClassName,
            onClick: this.toggleTooltip,
            onMouseEnter: this.showTooltip,
            onMouseLeave: this.hideTooltip
          },
          tooltipIcon ? tooltipIcon : _react2.default.createElement('i', { className: 'icon-question-solid' })
        )
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  tooltipVerticalAlignment: _propTypes2.default.oneOf(['top', 'bottom']),
  tooltipHorizontalAlignment: _propTypes2.default.oneOf(['left', 'right']),
  backgroundColor: _propTypes2.default.string,
  className: _propTypes2.default.string,
  iconContainerClassName: _propTypes2.default.string,
  tooltipIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  tooltipBubbleClassName: _propTypes2.default.string,
  tooltipBubbleArrowClassName: _propTypes2.default.string,
  tooltipBubbleContentClassName: _propTypes2.default.string
};
Tooltip.defaultProps = {
  className: undefined,
  iconContainerClassName: ''
};
exports.default = Tooltip;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tooltip/Tooltip.js